import { render, staticRenderFns } from "./saved-searches-item.vue?vue&type=template&id=66d897aa"
import script from "./saved-searches-item.vue?vue&type=script&lang=ts"
export * from "./saved-searches-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports